import { post } from './utils';

function unwrapJsonResult(data) {
    let jsonData = JSON.parse(data);
    return jsonData;
}

export default class ApiBackend2 {
    constructor(urlBackend2) {
        this.url = urlBackend2;
        this.extraParameters = {
            intDeviceType: 101,
            strClientVersion: 'ADMIN',
        };
        this.postHeaders = {
            'Content-Type': 'application/json',
        };
    }

    loginInfo = (credentials) => {
        return post(
            `${this.url}/fmanager2.svc/web/GetUserLoginRealm`,
            {
                ...this.extraParameters,
                email: credentials.username,
            },
            this.postHeaders,
        ).then(unwrapJsonResult);
    };

    getAuthenticationToken = (state, redirectUrl, authenticationType) => {
        return post(
            `${this.url}/fmanager2.svc/web/GetAuthenticationToken`,
            {
                ...this.extraParameters,
                email: state,
                password: redirectUrl,
                authenticationType: authenticationType,
            },
            this.postHeaders,
        ).then(unwrapJsonResult);
    };

    /* Gets the information about the logged in user */
    getUserInfo = () => {
        return post(
            `${this.url}/fmanager2.svc/web/GetUserInfo`,
            {
                ...this.extraParameters,
            },
            this.postHeaders,
        ).then(unwrapJsonResult);
    };
}
